// Modules
import { connect } from 'react-redux';
import Promise from 'bluebird';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { Page, PageHeader, PageContent, ActionSection } from 'components/page';
import { PrimaryButton } from 'components/widgets/buttons';
import { alerts } from 'modules/alerts/actions';
import { didQueryUpdate } from 'utils/filter-utils';
import CheckableActions from 'components/content-containers/tables/checkable-actions';
import CopyToClipboard from 'components/widgets/icons/copy-to-clipboard';
import Filters from 'modules/filters/filters';
import PeopleTable from 'components/models/person/people-table';
import Person from 'services/data/person';

import * as actions from './store/actions';


// Component
class EmailList extends React.Component {
  static propTypes = {
    people: PropTypes.array,
    fetching: PropTypes.bool,
    count: PropTypes.number,
    query: PropTypes.object,
    tag: PropTypes.string,
    settings: PropTypes.object
  };

  constructor() {
    super();

    this.state = {};

    this.search = this.search.bind(this);
    this.update = people => actions.set({ people });

    this.filterConfig = {
      basic: ['search', 'company'],
      advanced: [
        ['search', 'company', 'personStatus'],
        ['tags']
      ],
      defaults: { personStatus: ['Active'], tags: ['Decision Maker', 'IT'] }
    };
  }

  componentWillReceiveProps(nextProps) {
    if (didQueryUpdate(nextProps, this.props)) this.search(nextProps.query);
  }

  search(query) {
    actions.set({ fetching: true });
    const fullQuery = Person.formatQuery(query || this.props.query);
    delete fullQuery.limit;
    
    Promise.props({
      people: Person.find(fullQuery),
      count: Person.count({ where: fullQuery.where })
    })
      .then((response) => {
        // const checkedPeople = _.map(response.people, person => ({ checked: true, ...person }));
        actions.set({ fetching: false, count: response.count, people: response.people });
      })
      .catch(alerts.catchError);
  }

  render() {
    const { people, fetching } = this.props;
    const checked = _.filter(people, 'checked');
    const anyChecked = checked.length;
    const allEmails = _(checked).map('primaryEmail.email').compact().value();
    const chunks = _.chunk(allEmails, 500);

    return (
      <Page>
        <PageHeader title="Email List">
          <ActionSection>
            <Filters className={anyChecked ? 'hidden' : ''} config={this.filterConfig} />
            { !!anyChecked &&
              <CheckableActions list={people} update={this.update}>
                <div className="flex justify-content-between grow">
                  <div className="buttons">
                    { _.map(chunks, (emails, index) =>
                      <CopyToClipboard key={index} component={PrimaryButton} copyText={_.join(emails, ',')} tooltip={`Copy group ${index + 1} email addresses to your clipboard`}>
                        Copy Addresses ({emails.length})
                      </CopyToClipboard>
                    ) }
                  </div>
                  <h2 className="total-value">{checked.length} People ({allEmails.length} emails)</h2>
                </div>
              </CheckableActions>
            }
          </ActionSection>
        </PageHeader>
        <PageContent
          fetching={fetching}
          emptyText="No people, adjust your filters!"
          emptyTextIcon="svg/filter.svg"
          showEmptyText={!fetching && _.isEmpty(people)}
        >
          
          <PeopleTable people={people} update={this.update} />
        </PageContent>
      </Page>
    );
  }
}

// Exports
export default connect((state) => ({
  people: state.people.people,
  fetching: state.people.fetching,
  tag: state.people.selectedTag,
  count: state.people.count,
  query: state.location.query,
  settings: state.pageData.settings
}))(EmailList);
